export const ContactSpecialist = (fullFormState, coverageAmount, termLength, healthClass, quoteResults, redirect, onMultiFieldChange) => {
  const form = {...fullFormState};
  form.pages.quoter.isSelectOrTalk = "contactSpecialist";
  form.pages.quoter.coverageAmount = coverageAmount;
  form.pages.quoter.healthClass = healthClass;
  form.pages.quoter.premium = (quoteResults && quoteResults.length > 0 && quoteResults[0].monthlyRate) || null;
  onMultiFieldChange(form);
  redirect();
}
